export default {
  MOUNTED: 'audioPlayerMounted',
  NETWORK_ERROR: 'audioPlayerNetworkError',
  ERROR: 'audioPlayerError'
};
